<!-- eslint-disable vue/no-v-html -->
<template>
    <main class="layout__main--narrow layout__main--no-top-padding">
        <BaseHeader
            v-if="headerImage"
            :placeholder="pending"
            :image="headerImage"
        />
        <template v-if="page">
            <BaseSection>
                <template #title>
                    <h1>{{ page.title }}</h1>
                </template>
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="page.intro"
                    class="lead"
                    data-allow-anchor
                    v-html="page.intro"
                />
                <!-- eslint-enable vue/no-v-html -->
            </BaseSection>

            <FlexibleSections
                class="overview__flexible-sections"
                :sections="page ? page.sections : []"
                :placeholder="pending ? 'overview' : undefined"
            />
        </template>

        <BaseError
            v-else-if="error || notFound"
            :error="error || { statusCode: 404 }"
        />
    </main>
</template>

<script setup>
import booksOverviewQuery from '~/graphql/queries/books/overview.graphql';
import usePageQuery from '~/composables/usePageQuery';

const { variables } = useCraftVariables();
variables.uri = undefined;

const response = await useLazyAsyncQuery({
    query: booksOverviewQuery,
    variables: {},
});

const {
    craftEntry: page,
    headerImage,
    pending,
} = usePageQuery(
    response,
    { entryKey: 'page' }
);
</script>

<style lang="less">
.overview__flexible-sections {
    grid-column: 1/-1 !important; /* stylelint-disable-line declaration-no-important */
}
</style>
